package ui.components.organisms

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.attributes.*
import presentation.state.AppState
import ui.components.*
import domain.model.*

@Composable
fun DashboardContent(
    state: AppState,
    onRefresh: () -> Unit,
    onLogout: () -> Unit,
    onViewModeChange: (PRViewMode) -> Unit
) {
    if (!state.isAuthenticated) {
        // Login screen
        Div(
            attrs = {
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                    minHeight(60.vh)
                    textAlign("center")
                }
            }
        ) {
            H2(
                attrs = {
                    style {
                        marginBottom(16.px)
                        color(Color("var(--text-primary)"))
                    }
                }
            ) {
                Text("Welcome to PR Dashboard")
            }
            
            P(
                attrs = {
                    style {
                        marginBottom(24.px)
                        color(Color("var(--text-secondary)"))
                    }
                }
            ) {
                Text("Please log in to view your pull requests and insights")
            }
            
            A(
                href = "/api/oauth/github/login",
                attrs = {
                    classes("btn", "btn-primary")
                    style {
                        textDecoration("none")
                        padding(12.px, 24.px)
                        backgroundColor(Color("#0969da"))
                        color(Color.white)
                        borderRadius(6.px)
                        fontSize(16.px)
                        fontWeight("500")
                    }
                }
            ) {
                Text("🔐 Login with GitHub")
            }
        }
    } else {
        // Dashboard content
        Div(
            attrs = {
                style {
                    display(DisplayStyle.Flex)
                    gap(20.px)
                }
            }
        ) {
            // Sidebar placeholder
            Div(
                attrs = {
                    style {
                        width(300.px)
                        padding(16.px)
                        backgroundColor(Color("#f9fafb"))
                        borderRadius(8.px)
                    }
                }
            ) {
                H3 { Text("GitHub Integration") }
                P { Text("Organizations: ${state.organizations.size}") }
                P { Text("Actions: ${state.actions.size}") }
            }
            
            // Main content area
            Div(
                attrs = {
                    style {
                        flexGrow(1)
                        minHeight(70.vh)
                    }
                }
            ) {
                when {
                    state.isLoading -> {
                        LoadingSpinner()
                    }
                    else -> {
                        Div {
                            H2 { Text("Pull Requests") }
                            P { Text("Found ${state.pullRequests.size} pull requests") }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun LoadingSpinner() {
    Div(
        attrs = {
            style {
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center)
                height(200.px)
            }
        }
    ) {
        Div(
            attrs = {
                classes("loading-spinner")
                style {
                    width(40.px)
                    height(40.px)
                    border(4.px, LineStyle.Solid, Color("#f3f4f6"))
                    property("border-top", "1px solid #e5e7eb")
                    borderRadius(50.percent)
                    property("animation", "spin 1s linear infinite")
                }
            }
        )
    }
}

@Composable
private fun ErrorMessage(error: String) {
    Div(
        attrs = {
            style {
                padding(16.px)
                backgroundColor(Color("#fef2f2"))
                borderRadius(8.px)
                border(1.px, LineStyle.Solid, Color("#fecaca"))
                color(Color("#dc2626"))
            }
        }
    ) {
        Text("Error: $error")
    }
}